import React from "react";
import "./Education.css";

const educationData = [
  {
    institute: "National Institute of Technology, Jamshedpur",
    degree: "B.Tech - Mechanical Engineering",
    duration: "2023 - Present",
    description: "Materials, Manufacturing Processes, Process Optimization & More"
  },
  {
    institute: "Savitri Devi DAV Public School, Jamtara",
    degree: "Senior Secondary - AISSCE - CBSE Board",
    duration: "Aug 2020 - Mar 2022",
    description: "Percentage - 89.8%"
  },
  {
    institute: "Edwards English School, Jamtara",
    degree: "Secondary Examination - ICSE - CISCE Board",
    duration: "Mar 2020",
    description: "Percentage - 96.4% (District Topper - Jamtara)"
  }
];


function Education() {
  return (
    <section id="education" className="education-section">
      <div className="container">
        <h2 className="section-title">Education</h2>
        <div className="timeline">
          <div className="timeline-line"></div>
          {educationData.map(({ institute, degree, duration, description }, idx) => (
            <div key={idx} className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3>{institute}</h3>
                <span className="role">{degree}</span>
                <span className="duration">{duration}</span>
                <p>{description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Education;
